import type { RouteRecordRaw } from 'vue-router'
import AppLayout from '@/layouts/AppLayout.vue'

const routes: RouteRecordRaw[] = [
  // cms auth pages
  {
    name: 'cms-login',
    path: '/cms/login',
    component: () => import('@/views/auth/Login.vue'),
    meta: {
      title: 'Login',
      localeKey: 'auth.login',
    },
  },
  // cms pages
  {
    name: 'cms',
    path: '/cms',
    component: AppLayout,
    redirect: { name: 'dashboard' },
    children: [
      {
        name: 'dashboard',
        path: 'dashboard',
        component: () => import('@/views/dashboard/Dashboard.vue'),
        meta: {
          title: 'Dashboard',
          localeKey: 'menu.dashboard',
        },
      },
      {
        name: 'users',
        path: 'users',
        component: () => import('@/views/users/Users.vue'),
        meta: {
          title: 'Users',
          localeKey: 'menu.users',
        },
      },
      {
        name: 'coolers',
        path: 'coolers',
        component: () => import('@/views/coolers/Coolers.vue'),
        meta: {
          title: 'Coolers',
          localeKey: 'menu.coolers',
        },
      },
      {
        name: 'oils',
        path: 'oils',
        component: () => import('@/views/oils/Oils.vue'),
        meta: {
          title: 'Coolers',
          localeKey: 'menu.coolers',
        },
      },
      {
        name: 'preferences',
        path: 'preferences',
        component: () => import('@/views/preferences/Preferences.vue'),
        meta: {
          title: 'Preferences',
          localeKey: 'menu.preferences',
        },
      },
      {
        name: 'system',
        path: 'system',
        redirect: { name: 'system-admin-config' },
        children: [
          {
            name: 'system-calculate-config',
            path: 'calculate-config',
            component: () => import('@/views/system/calculate-config/index.vue'),
            meta: {
              title: 'Calculate Config',
              localeKey: 'menu.system.calculate',
            },
          },
          {
            name: 'system-admin-config',
            path: 'admin-config',
            component: () => import('@/views/system/admin-config/index.vue'),
            meta: {
              title: 'Admins Config',
              localeKey: 'menu.system.admin',
            },
          },
          {
            name: 'system-user-account-config',
            path: 'user-account-config',
            component: () => import('@/views/system/user-account-config/index.vue'),
            meta: {
              title: 'User Account Config',
              localeKey: 'menu.system.userAccount',
            },
          },
          {
            name: 'system-email-config',
            path: 'email-config',
            component: () => import('@/views/system/email-config/index.vue'),
            meta: {
              title: 'Email Config',
              localeKey: 'menu.system.email',
            },
          },
          {
            name: 'system-activate-email-config',
            path: 'activate-email-config',
            component: () => import('@/views/system/activate-email-config/index.vue'),
            meta: {
              title: 'Activate Email Config',
              localeKey: 'menu.system.activateEmail',
            },
          },
          {
            name: 'system-password-reset-email-config',
            path: 'password-reset-email-config',
            component: () => import('@/views/system/password-reset-email-config/index.vue'),
            meta: {
              title: 'Password Reset Email Config',
              localeKey: 'menu.system.passwordResetEmail',
            },
          },
          {
            name: 'system-icp-config',
            path: 'icp-config',
            component: () => import('@/views/system/icp-config/index.vue'),
            meta: {
              title: 'ICP Config',
              localeKey: 'menu.system.icp',
            },
          },
        ],
      },
      {
        name: 'logs',
        path: 'logs',
        redirect: { name: 'user-operation-logs' },
        children: [
          {
            name: 'user-operation-logs',
            path: 'user-operation-logs',
            component: () => import('@/views/user-logs/operation-logs.vue'),
            meta: {
              title: 'User Operation Logs',
              localeKey: 'menu.logs.userOperation',
            },
          },
          {
            name: 'user-login-logs',
            path: 'user-login-logs',
            component: () => import('@/views/user-logs/login-logs.vue'),
            meta: {
              title: 'User Login Logs',
              localeKey: 'menu.logs.userLogin',
            },
          },
        ]
      },
    ],
  },
]

export default routes
